export const FETCH_ROBOT_SUCCESS = "FETCH_ROBOT_SUCCESS";
export const FETCH_ROBOT_LOG_BUILD_SUCCESS = "FETCH_ROBOT_LOG_BUILD_SUCCESS";
export const POST_ROBOT_SUCCESS = "POST_ROBOT_SUCCESS";
export const PUT_ROBOT_START = "PUT_ROBOT_START";
export const PUT_ROBOT_SUCCESS = "PUT_ROBOT_SUCCESS";
export const PUT_ROBOT_ERROR = "PUT_ROBOT_ERROR";
export const ROBOT_CLEAR_TYPE = "ROBOT_CLEAR_TYPE";
export const DELETE_ROBOT_SUCCESS = "DELETE_ROBOT_SUCCESS";
